var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('common-title',{attrs:{"titleName":""}}),_c('div',{staticClass:"box"},[_c('img',{staticClass:"img",attrs:{"src":_vm.url,"alt":"成功"}}),_c('div',{staticClass:"text"},[_vm._v("信息已提交成功，将尽快为您发货")]),_c('div',{staticClass:"btn",on:{"click":_vm.goback}},[_vm._v("查看信息")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }